/**
 * Open a blank tab that the caller can navigate later.
 *
 * Warning: use this only from a direct user gesture and clear/detach the opener before
 * sending the tab to an external origin. For static external URLs, prefer a regular
 * `target="_blank" rel="noopener noreferrer"` link instead.
 */
export function openNewTab() {
    const newTab = window.open("", "_blank");
    if (newTab) {
        // Detach the blank tab before navigating to an external origin.
        newTab.opener = null;
    }
    return newTab;
}

/**
 * Navigate a previously opened tab, or fall back to redirecting the current tab.
 *
 * Warning: the caller must decide when to open the tab handle. For one-time or stateful
 * URLs returned from async work, open the tab first with {@link openNewTab} during the
 * user gesture and pass it in here so popup blockers do not redirect the current tab instead.
 */
export function openNewTabOrRedirect(url: string, newTab: Window | null) {
    if (tabIsAvailable(newTab)) {
        newTab.location.href = url;
        newTab.focus();
    } else {
        window.location.href = url;
    }
}

function tabIsAvailable(newTab: Window | null): newTab is Window {
    if (newTab == null) {
        return false;
    }

    try {
        return !newTab.closed;
    } catch {
        return false;
    }
}
